// extracted by mini-css-extract-plugin
module.exports = {"backgroundLinearBottom":"styles_backgroundLinearBottom__1unK6","backgroundFull":"styles_backgroundFull__112hI"};